import { Skeleton } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

import { BatchesPage } from '@contracts';

export const Route = createFileRoute('/_app/os/contracts_/$contractId/batches')(
  {
    component: BatchesPage,
    pendingComponent: () => <Skeleton h="100%" width="100%" />,
  },
);
